module.exports = "/assets/landing-dw/instagram/insta-feed-1.jpg?2ruWdZ1";